module.exports = __webpack_public_path__ + "img/symbol_3.781f6053.png";